import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '../../../../../../../../models/base/base-component';
import { StiiizyAddressCardStackContentViewModel } from '../stiiizy-address-card-stack-content-view-model';
import { StiiizyCardData } from '../../../../../../../../models/print-cards/stiiizy-card-data';

@Component({
  selector: 'app-stiiizy-address-side-bar',
  templateUrl: './stiiizy-address-side-bar.component.html',
  styleUrls: ['./stiiizy-address-side-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class StiiizyAddressSideBarComponent extends BaseComponent {
  constructor(
    public viewModel: StiiizyAddressCardStackContentViewModel // provided by parent component
  ) {
    super();
  }

  @Input() maxHeightInPx: number;
  @Input() maxWidthInPx: number;
  @Input() cardData: StiiizyCardData;

  setupViews() {}
  setupBindings() {}
}
